module.exports = __webpack_public_path__ + "static/site-1748617940196/img/logo_master.c8bdcd8d.svg";